import { FlexBox, IconButton } from '@dixa/lib-shared-habla';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useEffectOnce, useUnmount } from 'react-use';

import { useFeatureFlag } from 'utils/featureFlagging/useFeatureFlag';

import { DispatchProps, StateProps } from '../containers/timeline';

import { TimelineComponent } from './timelineComponent/timelineComponent';

type TimelineProps = {
  handleToggleTimeline: () => void;
} & StateProps &
  DispatchProps;

export const Timeline = ({
  requesterId,
  timelineData,
  currentConversationId,
  getTimeline,
  wsRequest,
  timelineClear,
  handleToggleTimeline,
}: TimelineProps): JSX.Element | null => {
  const flags = useFeatureFlag(['link-merge-conversations']);
  const navigate = useNavigate();

  useEffectOnce(() => {
    wsRequest({
      type: 'connection:subscribe',
      params: {
        type: 'conversation_events',
        events: ['closed', 'pending', 'opened'],
      },
    }).catch((exception) => {
      console.error(exception);
    });

    return () => {
      wsRequest({
        type: 'connection:unsubscribe',
        params: {
          type: 'conversation_events',
          events: ['closed', 'pending', 'opened'],
        },
      });
    };
  });

  useUnmount(() => {
    timelineClear();
  });

  useEffect(() => {
    if (requesterId) {
      getTimeline({ requesterId });
    }
  }, [getTimeline, requesterId]);

  const handleConversationSelection = (csid: number) => {
    navigate(`/conversation/${csid}`);
  };

  if (!timelineData) return null;

  return (
    <FlexBox
      height="100%"
      maxHeight="100%"
      flexDirection="column"
      background="var(--conversation-timeline-bg)"
    >
      {flags.linkMergeConversations && (
        <FlexBox
          data-timeline-details-expand-helper
          justifyContent="center"
          padding="200"
        >
          <IconButton
            variant="tertiary"
            onClick={handleToggleTimeline}
            icon="angle-double-right"
          />
        </FlexBox>
      )}

      <TimelineComponent
        items={timelineData.conversationsByDate}
        startDate={timelineData.dateFirstConversation}
        endDate={timelineData.dateLastConversation}
        onConversationSelect={handleConversationSelection}
        currentConversation={currentConversationId as number}
      />
    </FlexBox>
  );
};
